<template lang="pug">
aside-modal(:id="id", width="w-xxxl", :loading="onLoading('fetch-transaction')")
    span(slot="header-text") {{ hasTransaction && isVoided && !loading ? 'Voided' : '' }} Receipts
    div.padding.receipt(slot="body")
        div(v-if="hasTransaction && ! loading")
            receipt-details
            receipt-orders
            receipt-amount

            div(v-if="receipt.refund_id")
                receipt-return-orders
                receipt-return-amount

            receipt-footer
            receipt-loyalty
        div(v-else)
            h1.text-center
                v-loading(loader="fetch-transaction")

    button(
        slot="footer",
        :disabled="loading",
        @click="print()",
        class="btn btn-fw dark"
    ) Print
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import receiptDetails from './details.vue';
import receiptOrders from './orders.vue';
import receiptAmount from './amount.vue';
import receiptFooter from './footer.vue';
import receiptReturnOrders from './return-orders';
import receiptReturnAmount from './return-amount';
import receiptLoyalty from './loyalty';
import StoreMixin from './store-mixin';

export default {
    components: {
        receiptDetails,
        receiptOrders,
        receiptAmount,
        receiptFooter,
        receiptReturnOrders,
        receiptReturnAmount,
        receiptLoyalty,
    },

    mixins: [StoreMixin],

    props: {
        id: {
            type: String,
            default: 'receipt',
        },
    },

    computed: {
        ...mapGetters('transaction', ['receipt', 'hasTransaction', 'isVoided']),

        loading() {
            return this.onLoading('fetch-transaction');
        },
    },

    created() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('transaction', ['getTransaction']),

        print() {
            let refund_id = null;
            let voided = false;

            if (!_.isUndefined(this.receipt.refund_id)) {
                refund_id = this.receipt.refund_id;
            }

            if (!_.isUndefined(this.receipt.voided)) {
                voided = this.receipt.voided;
            }

            window.location.href = Laroute.route(
                'franchise.report.transaction.exportReceipt',
                {
                    id: this.receipt.transaction_id,
                    refund_id: refund_id,
                    voided: voided,
                },
            );
        },

        registerEvent() {
            this.$on('show-receipt', (transaction_id, refund_id, voided) => {
                if (this.loading) return;

                this.toggleModal('show');
                this.getTransaction({
                    id: transaction_id,
                    refund_id: refund_id,
                    voided: voided,
                });
            });
        },

        toggleModal(action) {
            $('#receipt').modal(action);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/receipt.vue